(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var REVEAL_SELECTOR = [
    '.bam-shop-by-platform__card',
    '.bam-category-tiles__tile',
    '.bam-service-tiles__card',
    '.bam-trust-badges__badge',
    '.bam-local-seo__card',
    '.bam-service-content__card',
    '.bam-product-support__card',
    '.bam-build-card',
    '.bam-build-results__stat',
    '.bam-build-details__card',
    '.bam-build-parts__item-wrap',
    '.bam-build-media__item',
    '.bam-build-related-services__card',
    '.bam-build-related-products__card',
    'main[data-template="index"] [data-testid="product-list"] .resource-list__item'
  ].join(',');

  var observed = new WeakSet();

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i += 1) {
      nodes[i].classList.add('is-revealed');
    }
  }

  function prepareNode(node, index) {
    if (observed.has(node)) return;
    observed.add(node);

    node.classList.add('bam-reveal');
    node.style.setProperty('--bam-reveal-delay', Math.min(index % 8, 7) * 0.07 + 's');
  }

  function initReveal() {
    var nodes = document.querySelectorAll(REVEAL_SELECTOR);
    if (!nodes.length) return;

    document.documentElement.classList.add('js-bam-animations');

    for (var i = 0; i < nodes.length; i += 1) {
      prepareNode(nodes[i], i);
    }

    if (!('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var j = 0; j < entries.length; j += 1) {
          var entry = entries[j];
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        rootMargin: '0px 0px -6% 0px',
        threshold: 0.12
      }
    );

    for (var k = 0; k < nodes.length; k += 1) {
      if (!nodes[k].classList.contains('is-revealed')) {
        observer.observe(nodes[k]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  document.addEventListener('shopify:section:load', initReveal);
  document.addEventListener('shopify:section:reorder', initReveal);
})();
